// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   Nura Baby CSV Import page
   Matches the app's dark wireframe design tokens
   ======================================== */

.nura-import-page {
    width: min(100%, 640px);
    margin: 0 auto;
    padding: 24px;
    background: var(--surface-bg);
    border-radius: 16px;
    border: 1px solid var(--wire-green);
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 10px 10px 26px 0 rgba(0, 0, 0, 0.35);
}

.nura-import-header h2 {
    margin: 0 0 6px;
}

.nura-import-subtitle {
    color: var(--muted, #9ca3af);
    font-size: 14px;
    margin-bottom: 18px;
}

.nura-import-section {
    padding: 16px 0;
    border-top: 1px solid var(--wire-green);
}

.nura-import-section-title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--wire-green);
}

.nura-import-field {
    display: block;
    margin-bottom: 12px;
}

.nura-import-field span {
    display: block;
    font-size: 13px;
    color: var(--muted, #9ca3af);
    margin-bottom: 6px;
}

.nura-import-field input[type='email'],
.nura-import-field input[type='password'],
.nura-import-field input[type='text'] {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--wire-green);
    border-radius: 8px;
    background: var(--panel-bg);
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
}

.nura-import-field input[type='file'] {
    color: #fff;
}

.nura-import-btn {
    background: var(--btn-bg);
    color: #fff;
    border: 1px solid var(--wire-green);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 14px;
    cursor: pointer;
}

.nura-import-btn:hover {
    background: var(--btn-bg-hover);
}

.nura-import-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.nura-import-status {
    font-size: 13px;
    margin-top: 10px;
    color: var(--muted, #9ca3af);
}

.nura-import-status.ok {
    color: var(--wire-green);
}

.nura-import-status.bad {
    color: var(--wire-red);
}

.nura-import-summary {
    display: flex;
    gap: 20px;
    margin-bottom: 12px;
}

.nura-import-skipped {
    margin: 0 0 12px;
    padding-left: 20px;
    font-size: 13px;
    color: var(--wire-peach);
}

.nura-import-json {
    background: var(--panel-bg);
    border: 1px solid var(--wire-green);
    border-radius: 8px;
    padding: 12px;
    font-size: 12px;
    overflow: auto;
    max-height: 260px;
    white-space: pre-wrap;
    word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/NuraImport/NuraImport.css"],"names":[],"mappings":"AAAA;;;6CAG6C;;AAE7C;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,mCAAmC;IACnC,2FAA2F;AAC/F;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":["/* ========================================\n   Nura Baby CSV Import page\n   Matches the app's dark wireframe design tokens\n   ======================================== */\n\n.nura-import-page {\n    width: min(100%, 640px);\n    margin: 0 auto;\n    padding: 24px;\n    background: var(--surface-bg);\n    border-radius: 16px;\n    border: 1px solid var(--wire-green);\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 10px 10px 26px 0 rgba(0, 0, 0, 0.35);\n}\n\n.nura-import-header h2 {\n    margin: 0 0 6px;\n}\n\n.nura-import-subtitle {\n    color: var(--muted, #9ca3af);\n    font-size: 14px;\n    margin-bottom: 18px;\n}\n\n.nura-import-section {\n    padding: 16px 0;\n    border-top: 1px solid var(--wire-green);\n}\n\n.nura-import-section-title {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 12px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--wire-green);\n}\n\n.nura-import-field {\n    display: block;\n    margin-bottom: 12px;\n}\n\n.nura-import-field span {\n    display: block;\n    font-size: 13px;\n    color: var(--muted, #9ca3af);\n    margin-bottom: 6px;\n}\n\n.nura-import-field input[type='email'],\n.nura-import-field input[type='password'],\n.nura-import-field input[type='text'] {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--wire-green);\n    border-radius: 8px;\n    background: var(--panel-bg);\n    color: #fff;\n    font-size: 14px;\n    box-sizing: border-box;\n}\n\n.nura-import-field input[type='file'] {\n    color: #fff;\n}\n\n.nura-import-btn {\n    background: var(--btn-bg);\n    color: #fff;\n    border: 1px solid var(--wire-green);\n    border-radius: 8px;\n    padding: 10px 14px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.nura-import-btn:hover {\n    background: var(--btn-bg-hover);\n}\n\n.nura-import-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.nura-import-status {\n    font-size: 13px;\n    margin-top: 10px;\n    color: var(--muted, #9ca3af);\n}\n\n.nura-import-status.ok {\n    color: var(--wire-green);\n}\n\n.nura-import-status.bad {\n    color: var(--wire-red);\n}\n\n.nura-import-summary {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 12px;\n}\n\n.nura-import-skipped {\n    margin: 0 0 12px;\n    padding-left: 20px;\n    font-size: 13px;\n    color: var(--wire-peach);\n}\n\n.nura-import-json {\n    background: var(--panel-bg);\n    border: 1px solid var(--wire-green);\n    border-radius: 8px;\n    padding: 12px;\n    font-size: 12px;\n    overflow: auto;\n    max-height: 260px;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
